var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83106 7.97328L5.27979 8.74099C5.86532 6.1914 8.16766 4.27917 10.9203 4.27917C14.1151 4.27917 16.7115 6.85245 16.7115 10.0104C16.7115 12.9924 14.3962 15.4533 11.4479 15.718C11.0583 15.7529 10.7203 16.0662 10.7203 16.4807C10.7203 16.8873 11.0572 17.2309 11.4813 17.1987C15.233 16.9142 18.2008 13.8007 18.2008 10.0104C18.2008 6.03305 14.9329 2.80078 10.9203 2.80078C7.53829 2.80078 4.6887 5.09667 3.87484 8.19812L3.12782 7.27363C2.87039 6.95502 2.40165 6.90415 2.08073 7.15839C1.75944 7.41293 1.70659 7.87802 1.96437 8.19702L3.80379 10.4733C3.94919 10.6527 4.16499 10.7495 4.38455 10.7495C4.49659 10.7495 4.61071 10.7243 4.71673 10.6722L7.49748 9.29571C7.86496 9.11381 8.01626 8.67005 7.83106 8.30354C7.64616 7.93765 7.19801 7.79168 6.83106 7.97328Z",
    fill: "#00CC52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/UndoIcon.f359388b.svg";
export { ForwardRef as ReactComponent };